<script>
  /**
   * Generic table.
   *
   * Adapted from plugins/augurly_admin/svelte/src/components/DataTable.svelte
   * (plugins/augurly has no reusable table at all). One deliberate change:
   * augurly_admin renders cells with {@html column.render(row)}, which is an
   * XSS vector. This portal displays guest-authored message bodies and property
   * names sourced from an external API, so `render` returns text and is
   * interpolated safely. A column that genuinely needs markup supplies a
   * `snippet` instead, which Svelte escapes correctly.
   */
  let {
    columns = [],
    rows = [],
    loading = false,
    emptyMessage = 'Nothing to show yet.',
    onRowClick = null,
    rowKey = (row) => row.id,
  } = $props();
</script>

<div class="p-card overflow-x-auto">
  <table class="w-full text-left text-sm">
    <thead>
      <tr style="border-bottom: 1px solid var(--p-border)">
        {#each columns as col}
          <th class="whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide p-muted"
              class:text-right={col.align === 'right'}>
            {col.label}
          </th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#if loading}
        <tr>
          <td colspan={columns.length} class="px-4 py-10 text-center p-muted">
            <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent"
                  style="color: var(--p-brand)"></span>
          </td>
        </tr>
      {:else if !rows.length}
        <tr>
          <td colspan={columns.length} class="px-4 py-10 text-center p-muted">{emptyMessage}</td>
        </tr>
      {:else}
        {#each rows as row (rowKey(row))}
          <tr style="border-top: 1px solid var(--p-border)"
              class:cursor-pointer={!!onRowClick}
              class="hover:bg-[var(--p-bg-subtle)]"
              onclick={() => onRowClick?.(row)}>
            {#each columns as col}
              <td class="px-4 py-3 align-top" class:text-right={col.align === 'right'}>
                {#if col.snippet}
                  {@render col.snippet(row)}
                {:else if col.render}
                  {col.render(row)}
                {:else}
                  {row[col.key] ?? '—'}
                {/if}
              </td>
            {/each}
          </tr>
        {/each}
      {/if}
    </tbody>
  </table>
</div>
